import { REQUEST_ANALISE_SIGNAL, RESPONSE_ANALISE_SIGNAL, REQUEST_ANALISE_SIGNAL_FAILURE } from "../actions/analiseSignalActions";

import { states as queriesStates } from "./queriesStates";

const initialState = {
  analiseSignalDataState: queriesStates.NOT_REQUESTED,
  analiseSignals: { connections: [] },
  errors: null,
};

const analiseSignalsReducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_ANALISE_SIGNAL: {
      return Object.assign({}, state, {
        analiseSignalDataState: queriesStates.REQUEST,
        analiseSignals: { connections: [] },
      });
    }
    case RESPONSE_ANALISE_SIGNAL: {
      return Object.assign({}, state, {
        analiseSignalDataState: queriesStates.READY,
        analiseSignals: action.data,
      });
    }
    case REQUEST_ANALISE_SIGNAL_FAILURE: {
      return Object.assign({}, state, {
        analiseSignalDataState: queriesStates.FAILURE,
        errors: action.errors,
      });
    }
    default:
      return state;
  }
};

export default analiseSignalsReducer;
